/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerabouten2Inputs */

const en_organizerabouten2 = /** @type {(inputs: Organizerabouten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About in English (optional)`)
};

const de_organizerabouten2 = /** @type {(inputs: Organizerabouten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über dich auf Englisch (freiwillig)`)
};

/**
* | output |
* | --- |
* | "About in English (optional)" |
*
* @param {Organizerabouten2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerabouten2 = /** @type {((inputs?: Organizerabouten2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerabouten2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerabouten2(inputs)
	return de_organizerabouten2(inputs)
});
export { organizerabouten2 as "organizerAboutEn" }